import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import Text from "@/bit/components/components.text";
import CustomLink from "@/bit/components/components.custom-link";
const IconGlyph = dynamic(() => import("@/bit/components/components.icon-glyph"));

const isProperSchedule = (openingTime, closingTime, alwaysVisible) => {
    if (alwaysVisible === 'true') {
        return true;
    }
    let properSchedule = false;
    if (openingTime && closingTime && typeof window !== "undefined") {
        // Función para convertir una hora en formato "HH:MM" a minutos totales
        const timeToMinutes = (time) => {
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        };

        const now = new Date();
        const currentMinutes = now.getHours() * 60 + now.getMinutes();

        const openingMinutes = timeToMinutes(openingTime);
        const closingMinutes = timeToMinutes(closingTime);

        // Verifica si la hora actual está dentro del rango
        properSchedule = currentMinutes >= openingMinutes && currentMinutes <= closingMinutes;
    }
    return properSchedule;
};


function CmsClickToCall(props) {

    const [properSchedule, setProperSchedule] = useState(true);
    const { openingTime, closingTime, cmsHandler, layout, alwaysVisible } = props;

    useEffect(() => {
        setProperSchedule(isProperSchedule(openingTime, closingTime, alwaysVisible));
    })

    const mainText = props["cms-atom-text-1"];
    const secondaryText = props["cms-atom-text-2"];
    const secondaryTextLink = props["cms-atom-link-1"];

    return (
        ((mainText?.text) || cmsHandler) && (
            <div className={`c2c layout-${layout} ${properSchedule ? 'visible':'no-visible'}`}>
                {cmsHandler && (
                    <span
                        className={"element-editable block edit-component cms-c2c-placeholder"}
                        onClick={() =>
                            cmsHandler({
                                ...props,
                                name: "cms-block.cms-click-to-call",
                            })
                        }
                    >
                        <IconGlyph id="telefono-m" height={20} color="white" />
                    </span>
                )}
                <Text
                    {...mainText}
                    cmsHandler={cmsHandler}                   
                />
                <CustomLink
                    {...secondaryTextLink}
                    cmsHandler={cmsHandler}
                    >
                    <div className="phone-gap">
                        <Text
                            {...secondaryText}                          
                             cyData= "SimplePhone Desktop Phone Text"
                            cmsHandler={cmsHandler}
                        />
                    </div>
                </CustomLink>
                <style jsx>{`.c2c {
  position: relative;
  display: flex;
  flex-direction: column;
  height: fit-content;
  
  &.layout-horizontal {
    flex-direction: row;
    gap: 0.3rem;
    @media screen and (max-width: 910px) {
      flex-direction: column !important;
      gap: 0.5rem;
    }
  }
  &.layout-vertical {
    gap: 0rem;
    @media screen and (max-width: 910px) {
      gap: 0.3rem;
      align-items: center;
    }
  }
  @media screen and (max-width: 910px) {
    flex-direction: row;
    order: 4;
  }
  .phone-gap p {
    line-height: 26px !important; //considerando body4 y t5
  }
}
`}</style>
            </div>
        ));
}

CmsClickToCall.propTypes = {
    /**
     * {
     *  "info": "Layout en desktop (vertical u horizontal), siendo en mobile lo contrario",
     *  "kind": "both",
     *  "beautifulName": "Layout en desktop",
     *  "values": "./enums.js:LAYOUT_TYPES"
     * }
     */
    layout: PropTypes.oneOf(["horizontal", "vertical"]),
    /**
     * {
     *  "info": "Siempre visible independientemente de la hora",
     *  "kind": "both",
     *  "beautifulName": "Siempre visible"
     * }
     */
    alwaysVisible: PropTypes.bool,
    /**
     * {
     *  "info": "Hora de inicio de visibilidad del C2C",
     *  "kind": "both",
     *  "beautifulName": "Inicio de la visibilidad del C2C"
     * }
     */
    openingTime: PropTypes.string,
    /**
     * {
     *  "info": "Hora de fin de visibilidad del C2C",
     *  "kind": "both",
     *  "beautifulName": "Fin de la visibilidad del C2C"
     * }
     */
    closingTime: PropTypes.string,
};

export default CmsClickToCall;
